import { Box, CounterBadge, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import {
  Dismiss as DismissIcon,
  Chat as ChatIcon,
} from '@wix/wix-ui-icons-common';

import { DATA_HOOKS } from '../../../dataHooks';
import { SparklesIcon } from '../../../icons/SparklesIcon';
import { useStore } from '../../../zustand/stores';

import css from './index.module.scss';

type CopilotHeaderProps = {
  onChatClick: () => void;
  onCloseClick: () => void;
  dismissDataHook: string;
};

export const CopilotHeader = ({
  onChatClick,
  onCloseClick,
  dismissDataHook,
}: CopilotHeaderProps) => {
  const { user } = useStore((state) => state.userSlice);
  const { isChatbotInitializing, isChatbotReady, unreadMessagesCount } = useStore(
    (state) => state.copilotSlice
  );
  const { t } = useTranslation();

  return (
    <>
      <Box className={css.headerContainer} align="space-between">
        <Box gap="8px">
          <div className={css.copilotIcon}>
            <SparklesIcon />
          </div>
          <Heading className={css.copilotTitle} size="medium">
            {t('article-page.copilot.title')}
          </Heading>
        </Box>
        <Box direction="horizontal" className={css.iconsWrapper}>
          {(isChatbotReady || unreadMessagesCount > 0) && (
            <Box>
              {unreadMessagesCount > 0 && (
                <CounterBadge className={css.counterBadge} skin="danger" size="small">
                  {unreadMessagesCount}
                </CounterBadge>
              )}
              <ChatIcon className={css.chatIcon} onClick={onChatClick} />
            </Box>
          )}
          <DismissIcon
            className={css.dismissIcon}
            data-hook={dismissDataHook}
            onClick={onCloseClick}
          />
        </Box>
      </Box>
      {!isChatbotInitializing && (
        <Box direction="vertical" paddingTop="SP4">
          <Heading
            dataHook={DATA_HOOKS.ARTICLE_RIGHT_SIDEBAR_USER_NAME_TITLE}
            className={css.userNameTitle}
            size="large"
          >
            {t('article-page.copilot.user.title', {
              name: user?.firstName || '',
            })}
          </Heading>
          <Text
            weight="normal"
            className={css.userNameSubtitle}
            dataHook={DATA_HOOKS.ARTICLE_RIGHT_SIDEBAR_USER_NAME_SUBTITLE}
          >
            {t('article-page.copilot.user.subtitle')}
          </Text>
        </Box>
      )}
    </>
  );
};
